import styled from 'styled-components';
import { ReactComponent as ScaleIcon } from 'assets/svg/imports/scale.svg';
import { colourPalette } from 'styles/styles';

export const MapStepStyle = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
  `,
  ScaleIcon: styled(ScaleIcon)`
    height: 16px;
    width: 16px;
    path {
      fill: ${colourPalette.fuchsia400};
    }
  `,
};
